import { Facebook, Instagram } from 'react-feather'
import XLogo from '../shared/XLogo'
import pluralize from 'pluralize'

const toCamelCase = str => str.replace(/_([a-z])/g, (_, c) => c.toUpperCase());

class SocialAccountProvider {
  constructor(json) {
    Object.keys(json).forEach((key) => {
      Object.defineProperty(this, toCamelCase(key), {
        get: () => json[key],
      })
    })
  }

  accountDisplayName(name) {
    switch(this.name) {
      case 'twitter':
      case 'instagram':
        return `@${name}`
      default:
        return name
    }
  }

  get icon() {
    switch(this.name) {
      case 'facebook':
        return Facebook
      case 'twitter':
        return XLogo
      case 'instagram':
        return Instagram
    }
  }

  tooManyAssets(selectedFiles) {
    const assetCounts = this.assetCounts(selectedFiles)

    if(this.allowsMixedMedia) {
      return assetCounts.video + assetCounts.image > this.maxFilesPerPost
    } else {
      return assetCounts.image > this.maxFilesPerPost
    }
  }

  messageOverLength(message) {
    return message.length > this.maxCharsPerPost
  }

  // expects selectedFiles from multipost state
  assetCounts(selectedFiles) {
    let assetCounts = {
      video: 0,
      image: 0,
      story: 0,
    }

    selectedFiles.forEach(file => {
      file.assets.forEach(asset => {
        asset.enabledActions.forEach(action => {
          if(action.provider !== this.name) {
            return
          }
          if(action.story) {
            assetCounts.story++
          } else if(asset.video) {
            assetCounts.video++
          } else {
            assetCounts.image++
          }
        })
      })
    })

    return assetCounts
  }

  // expects selectedFiles and messages from multipost state
  postCount(selectedFiles, messages) {
    const message = messages[this.name]?.value || messages.default.value

    let postCount = 0
    let postDescriptions = []
    const assetCounts = this.assetCounts(selectedFiles)

    // each story is it's own post
    if(this.supportsStory) {
      postCount += assetCounts.story
      assetCounts.story > 0 && postDescriptions.push([assetCounts.story, this.title, pluralize('Story', assetCounts.story, false)].join(' '))
    }

    if(assetCounts.image + assetCounts.video > 0) {
      // if mixed media is allowed, it's one post
      if(this.allowsMixedMedia) {
        postCount += 1
        postDescriptions.push([1, this.title, this.postName].join(' '))
      // otherwise, each video is it's own post
      }else{
        postCount += assetCounts.image > 0 ? 1 : 0
        postCount += assetCounts.video

        let baseDesc = [pluralize(`${this.title} ${this.postName}`, assetCounts.image > 0 ? 1 : 0 + assetCounts.video, true)].join(' ')

        if(assetCounts.video > 0){
          const parenthetical = [pluralize('video', assetCounts.video, true), "1 with graphics"].join(", ")
          postDescriptions.push([baseDesc, `(${parenthetical})`].join(' '))
        }else{
          postDescriptions.push(baseDesc)
        }

      }
    } else {
      if(this.allowsTextOnly && message.length > 0) {
        postCount += 1
        postDescriptions.push([1, this.title, this.postName, '(text only)'].join(' '))
      }
    }

    return { postCount, postDescriptions }
  }

  static providers = []

  static load(jsonArray) {
    SocialAccountProvider.providers = jsonArray.map(json => new SocialAccountProvider(json))

    SocialAccountProvider.providers.forEach((provider) => {
      if(!Object.hasOwn(SocialAccountProvider, provider.name)) {
        Object.defineProperty(SocialAccountProvider, provider.name, {
          get: () => SocialAccountProvider.find(provider.name),
        })
      }
    })

    return SocialAccountProvider.providers
  }

  static all() {
    return SocialAccountProvider.providers
  }

  static find(name) {
    return SocialAccountProvider.providers.find((provider) => provider.name === name)
  }
}

export default SocialAccountProvider